<app-modal [title]="'Change Password'" [(visible)]="visible" [close]="close()">

    <ng-content #modalShow ngProjectAs="modal-show" select="modal-show"/>

    <div #modalContent ngProjectAs="modal-content">

        <div class="mb-4">
            <p class="font-light">A change of password is required. Enter and confirm your old and new passwords below.</p>
        </div>

        <form [formGroup]="form" (ngSubmit)="onSubmit()">

            <app-form-control [(control)]="form.controls.oldPassword" [type]="'password'"/>

            <hr class="mt-0"/>
    
            <app-form-control [(control)]="form.controls.newPassword" [type]="'password'"/>
            <app-form-control [(control)]="form.controls.confirmPassword" [type]="'password'"/>
   
            <div class="d-flex flex-column gap-1">
                <app-modal-form-button-group [buttons]="['submit']" [form]="form" 
                    [opts]="{
                        values:{
                            submit: 'Change'
                        }
                    }"
                />
    
                @if(signout()){
                    <app-modal-form-button-group [buttons]="['back']" [form]="form" 
                        [opts]="{
                            values:{
                                back: 'Sign-out'
                            }
                        }"
                        (back)="onSignOut()"
                    />
                }
            </div>

            <span class="font-size-08rm font-light">*Due to security reasons, a re-login will be required on change.</span>     
    
        </form>  
    </div>

</app-modal>